import { module } from 'angular'
import { HotkeysService } from './hotkeys.service'
module('webregister.components').service('hotkeysService', HotkeysService)
